import React, { useCallback, useRef, useState } from 'react';
import { base64ToStream } from '../../../utils/fileUtils';

const useExamPhoto = ({ onSave }) => {
  const [visible, setVisible] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [addToReport, setAddToReport] = useState(undefined);
  const webcamRef = React.useRef(null);
  const onSaveRef = useRef(onSave);
  onSaveRef.current = onSave;

  const videoConstraints = { aspectRatio: 16 / 9 };

  const capture = useCallback(async () => {
    if (imageSrc) {
      const file = base64ToStream(imageSrc, 'image/png', 'foto-webcam.png');
      setVisible(false);
      setImageSrc(null);
      setAddToReport(undefined);
      await onSaveRef.current(file, addToReport ?? false);
      return;
    }
    setImageSrc(webcamRef.current.getScreenshot());
  }, [imageSrc, addToReport]);

  const resetImage = useCallback(() => {
    setImageSrc(null);
    setAddToReport(undefined);
  }, []);

  const openModal = useCallback(() => setVisible(true), []);

  const closeModal = useCallback(() => {
    setVisible(false);
    setImageSrc(null);
    setAddToReport(undefined);
    if (webcamRef.current) {
      const stream = webcamRef.current.stream;
      if (stream) {
        stream.getTracks().forEach(track => track.stop());
      }
    }
  }, []);

  return {
    visible,
    openModal,
    closeModal,
    capture,
    imageSrc,
    webcamRef,
    resetImage,
    videoConstraints,
    method: 'webcam',
    addToReport,
    setAddToReport,
  };
};

export default useExamPhoto;
